export default{
    SECRET: 'ikhodi'
}